import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { icon: '🏗️', title: 'Select Material', desc: 'Choose cement or other materials you need.' },
  { icon: '💬', title: 'Get Quote', desc: 'Receive transparent pricing and credit options.' },
  { icon: '🚚', title: 'Track Delivery', desc: 'Monitor your order until it arrives.' },
];

const HowItWorks = () => (
  <motion.section
    className="max-w-5xl mx-auto py-10 md:py-16 px-2 md:px-4"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.8, ease: 'easeOut' }}
  >
    <h2 className="text-xl md:text-2xl font-bold text-center text-primary mb-8 md:mb-10">How It Works</h2>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
      {steps.map((step, i) => (
        <div key={i} className="flex flex-col items-center bg-white rounded-xl shadow-soft p-4 md:p-6">
          <span className="text-3xl md:text-4xl mb-4">{step.icon}</span>
          <h3 className="text-base md:text-lg font-semibold text-primary mb-2">{step.title}</h3>
          <p className="text-primary text-center text-sm md:text-base">{step.desc}</p>
        </div>
      ))}
    </div>
  </motion.section>
);

export default HowItWorks; 